import { render, staticRenderFns } from "./CompetitionStatusBadge.vue?vue&type=template&id=ce17a6b8&scoped=true"
import script from "./CompetitionStatusBadge.vue?vue&type=script&lang=ts"
export * from "./CompetitionStatusBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce17a6b8",
  null
  
)

export default component.exports